export const NAVBAR_ABOUT_US = {
    ru: "О нас",
    en: "About Us",
    uz: "Биз ҳақимизда"
}

export const NAVBAR_OUR_TEAM = {
    ru: "Наша команда",
    en: "Our Team",
    uz: "Бизнинг жамоа"
}

export const NAVBAR_OUR_CUSTOMERS = {
    ru: "Наши клиенты",
    en: "Our clients",
    uz: "Бизнинг мижозларимиз"
}

export const NAVBAR_CONTACTS = {
    ru: "Контакты",
    en: "Contacts",
    uz: "Контактлар"
}

export const HEADING_TITLE = {
    ru: "Themis Legal",
    en: "Themis Legal",
    uz: "Themis Legal"
}

export const HEADING_DESCRIPTION = {
    ru: "Мы — первая юридическая компания в Узбекистане, специализирующаяся на оказании юридического сопровождения в сфере спорта.",
    en: "We are the first law firm in Uzbekistan focused on rendering legal services to the sports sector.",
    uz: "Биз Ўзбекистонда спорт соҳасида юридик ёрдам кўрсатишга ихтисослашган биринчи юридик компания."
}

export const CONTACT_US_BUTTON = {
    ru: "Свяжитесь с нами",
    en: "Get in touch",
    uz: "Биз билан боғланинг"
}

export const LOOKING_FOR_TITLE = {
    ru: "Ищете юридические услуги международного уровня?",
    en: "Looking for a Legal Service With Global Quality?",
    uz: "Жаҳон Сифатидаги Ҳуқуқий Хизмат Қидирмоқдамисиз?"
}

export const ABOUT_US_TITLE = {
    ru: "О нас",
    en: "About Us",
    uz: "Биз Ҳакимизда"
}

export const ABOUT_US_P1 = {
    ru: "Themis Legal была основана в 2021 году как бутиковая юридическая фирма, специализирующаяся на спортивном праве.",
    en: "Themis Legal was founded in 2021, but within this short period of time became the leading law firm in Uzbekistan advising clients in the sports sector across a broad range of areas.",
    uz: "Themis Legal 2021 йилда ташкил этилган, аммо қисқа вақт ичида спорт соҳасида кенг турдаги хизматлар кўрсатувчи етакчи юридик фирмага айланди."
}

export const ABOUT_US_P2 = {
    ru: "Наши юристы, дополнительно, оказывают юридическое сопровождение в таких сферах права как корпоративное, коммерческое, договорное и IP. Мы оказываем наши услуги как в Узбекистане, так и за рубежом.",
    en: "Our specialist team of sports lawyers represents sports governing bodies, sportsmen, agents, football clubs, Uzbekistan Football Association, Professional Football League in Uzbekistan and other companies linked to sporting activity. We provide bespoke legal support both domestically and internationally.",
    uz: "Бизнинг мижозларимиз қаторига спорт федерациялари, спортчилар, спорт агентлари, футбол клублари ва Ўзбекистон футбол ассоциацияси киради. Биз Ўзбекистонда ҳам, хорижда ҳам низоларни ҳал қилишга ёрдам берамиз."
}

export const ABOUT_US_EXPERIENCE_TITLE = {
    ru: "Опыт",
    en: "Experience",
    uz: "Самарадорлик"   
}

export const ABOUT_US_EXPERIENCE_DESCRIPTION = {
    ru: "Более 100+ разрешенных кейсов в судах общей юрисдикции и спортивных инстанциях (ФИФА, КАС).",
    en: "More than 1000 court proceedings representing clients in sensitive matters, incliding disputes resolution before FIFA’s Judicial Bodies and the Court of Arbitration for Sport (CAS).",
    uz: "Сиз ўзингизнинг спорт ютуқларингизга эътибор қаратганингизда, бизнинг максимал юридик ёрдамимизга ишонишингиз мумкин."
}

export const ABOUT_US_SERVICES_TITLE = {
    ru: "Услуги",
    en: "Services",
    uz: "Хизматлар"   
}

export const ABOUT_US_SERVICES_DESCRIPTION = {
    ru: "Оказываем полное юридическое сопровождение от правовой экспертизы контрактов, составления регламентирующих документов для организаций до представления интересов клиента во всех инстанциях.",
    en: "Our firm provides full legal support ranging from contractual expertise to representing clients before judicial bodies. Our team was entrusted to develop all sports regulations in relation to football in Uzbekistan.",
    uz: "Компания шартномаларни ҳуқуқий экспертизадан ўтказишдан тортиб, спорт инстанцияларида мижознинг манфаатларини ҳимоя қилишгача бўлган тўлиқ ҳуқуқий ёрдамни тақдим этади."
}

export const ABOUT_US_TEAM_TITLE = {
    ru: "Команда",
    en: "Team",
    uz: "Жамоа"   
}

export const ABOUT_US_TEAM_DESCRIPTION = {
    ru: "Мы - молодая команда профессиональных юристов, внимательных к каждому клиенту и его проблеме. Ведём дела на трех языках (узбекский, русский, английский).",
    en: "The firm brings together a young team of professional sports lawyers who are attentive to each client and their problem. We communicate in Russian, English and Uzbek.",
    uz: "Компания ҳар бир мижозга ва унинг муаммосига эътиборли бўлган профессионал юристларнинг ёш жамоасини бирлаштиради. Биз ўз ишларимизни уч тилда (ўзбек, рус, инглиз) олиб борамиз."   
}

export const ABOUT_US_BUDGET_TITLE = {
    ru: "Доступность",
    en: "Budget",
    uz: "Оммабоплик"   
}

export const ABOUT_US_BUDGET_DESCRIPTION = {
    ru: "Мы отличаемся лояльным подходом к оцениванию наших услуг с учетом финансовых возможностей клиента.",
    en: "We are distinguished by cost-effective approaches, taking into account financial capabilities of the client.",
    uz: "Биз мижозларнинг молиявий имкониятларини ҳисобга олган ҳолда хизматларимизни баҳолашга содиқ ёндашувимиз билан ажралиб турамиз."   
}

export const FOCUS_ON_ACHIEVEMENTS_TITLE = {
    ru: "Будьте спокойны за свои дела",
    en: "Focus on your achievements",
    uz: "Муваффақият сари олға қадам босинг!"
}

export const FOCUS_ON_ACHIEVEMENTS_DESCRIPTION = {
    ru: "Вы можете рассчитывать на нашу максимальную юридическую поддержку по любым вопросам, пока будете сосредоточены на своих достижениях.",
    en: "You can rely on our bespoke, top-level legal support while being focused on your sports achievements.",
    uz: "Бизнинг юристлар 1000 дан ортиқ суд жараёнларида, жумладан Спорт арбитраж судида (CAS) ва ФИФA юрисдикцион инстанцияларида иштирок этган. Ўзбекистонда футбол бўйича барча меъёрий ҳужжатлар яратилишига ҳам бизга ишонч билдирилди."
}

export const FOCUS_ON_ACHIEVEMENTS_QUOTE = {
    ru: "Благодаря разностороннему опыту наших юристов, мы сможем вовремя обозначить проблему и найти верное решение.",
    en: "Our experienced team will be able to identify the problem in time and find the right solution.",
    uz: "Биз нафақат Ўзбекистонда, балки ҳорижда ҳам низоларни ҳал қилишга ёрдам берамиз."
}

export const OUR_TEAM_TITLE = {
    ru: "Наша команда",
    en: "Our Team",
    uz: "Бизнинг Жамоа"
}

export const OUR_TEAM_PARTNER1_TITLE = {
    ru: "AKMAL KHUSANBAEV, Партнёр",
    en: "AKMAL KHUSANBAEV, Partner",
    uz: "AKMAL KHUSANBAEV, Юрист"
}

export const OUR_TEAM_PARTNER1_INFO = {
    ru: [
        "Высшее юридическое образование – Национальный Университет Узбекистана, юридический факультет;",
        "10 + лет опыта работы в сфере корпоративного, трудового, гражданского, налогового, таможенного, банковского и спортивного права;",
        "Более 1000 разрешенных судебных прецедентов."
    ],
    en: [
        "Higher Education - National University of Uzbekistan, Law degree;",
        "10+ years of experience in the field of corporate, civil, tax, labor, customs, banking and sports law;",
        "More than 1000 resolved court disputes."
    ],
    uz: [
        "Олий юридик маълумот – Ўзбекистон Миллий университети, юридик факултети;",
        "Корпоратив, меҳнат, фуқаролик, солиқ, божхона, банк ва спорт ҳуқуқи бўйича 10+ йиллик тажриба;",
        "1000 дан ортиқ ҳал қилинган суд ишлари."
    ]
}

export const OUR_TEAM_PARTNER1_GMAIL = {
    ru: "akhusanbaev@gmail.com",
    en: "akhusanbaev@gmail.com",
    uz: "akhusanbaev@gmail.com"
}

export const OUR_TEAM_PARTNER1_PHONE = {
    ru: "+998901110010",
    en: "+998901110010",
    uz: "+998901110010"
}

export const OUR_TEAM_PARTNER2_TITLE = {
    ru: "ANGELINA LIVERKO, Партнёр",
    en: "ANGELINA LIVERKO, Partner",
    uz: "ANGELINA LIVERKO, Юрист"
}

export const OUR_TEAM_PARTNER2_INFO = {
    ru: [
        "University of London, LLB;",
        "Карлов Университет (Чехия), LLM, факультет спортивного права;",
        "Профессиональный опыт в юридическом сопровождении футбольных клубов и спортсменов.",
        "Real Madrid Graduate School - Europea Universidad, LLM в международном спортивном праве"
    ],
    en: [
        "University of London, LLB;",
        "Charles University (Czech Republic, Prague), LLM in Sports Law;",
        "Experience in the representation of football clubs and professional sportsmen.",
        "Real Madrid Graduate School - Europea Universidad LLM in International Sports Law"
    ],
    uz: [
        "Лондон университети, LLB;",
        "Чарлз университети (Чехия), LLM, Спорт ҳуқуқи факултети;",
        "Футбол клублари ва спортчиларни ҳуқуқий қўллаб-қувватлаш бўйича профессионал тажриба.",
        "Real Madrid Graduate School - Europea Universidad, LLM халқаро Sport ҳуқуқида"
    ]
}

export const OUR_TEAM_PARTNER2_GMAIL = {
    ru: "angelina.liverko@gmail.com",
    en: "angelina.liverko@gmail.com",
    uz: "angelina.liverko@gmail.com"
}

export const OUR_CUSTOMERS_TITLE = {
    ru: "Среди наших клиентов",
    en: "Some of our clients",
    uz: "Мижозларимиз орасида"
}

export const OUR_CONTACTS_TITLE = {
    ru: "Наши Контакты",
    en: "Our Contacts",
    uz: "Контактлар"
}

export const OUR_CONTACTS_DESCRIPTION = {
    ru: "Если вы хотите узнать более подробно о том, как мы можем вам помочь, или о нашей работе, свяжитесь с нами:",
    en: "If you wish to find out more about how we can help you or about our work, please feel free to contact us:",
    uz: "Сизга қандай ёрдам беришимиз ёки фаолиятимиз ҳақида кўпроқ билмоқчи бўлсангиз, биз билан боғланинг:"
}

export const OUR_CONTACTS_TG = {
    ru: "+998 97 450 04 40 (Telegram, WhatsApp)",
    en: "+998 97 450 04 40 (Telegram, WhatsApp)",
    uz: "+998 97 450 04 40 (Telegram, WhatsApp)"
}

export const OUR_CONTACTS_PHONE = {
    ru: "+998 97 450 04 40 (для звонков)",
    en: "+998 97 450 04 40 (for calls)",
    uz: "+998 97 450 04 40 (қўнғироқлар учун)"
}

export const OUR_CONTACTS_GMAIL = {
    ru: "themislegaluz@gmail.com",
    en: "themislegaluz@gmail.com",
    uz: "themislegaluz@gmail.com"
}

export const OUR_CONTACTS_ADDRESS = {
    ru: "Узбекистан, город Ташкент, улица Ислама Каримова, 98А",
    en: "Uzbekistan, Tashkent city, Islam Karimov street, 98A",
    uz: "O‘zbekiston, Toshkent shahri, Islom Karimov ko‘chasi, 98A"
}